<template>
  <div class="map-info-table block lg:flex lg:items-center">
    <!-- 推奨航路参照率 -->
    <div class="recommended-route-reference-rate w-full lg:w-64">
      <span class="aisea-text-14-600-dark-gray">推奨航路参照率</span>
      <span class="reference-rate-value"
        >{{ routeAgreementRate
        }}<span class="reference-rate-unit">%</span></span
      >
    </div>
    <!-- 区切り線(タブレット、PC) -->
    <div class="vertical-divider hidden lg:block"></div>
    <!-- 区切り線(スマホ) -->
    <vs-divider class="block lg:hidden m-0"></vs-divider>
    <!-- テーブル -->
    <div class="table-right">
      <table class="route-data-table">
        <tr>
          <th></th>
          <template v-for="key in Object.keys(tableHeaderData)">
            <th class="item-category-label">
              {{ tableHeaderData[key].value }}
            </th>
          </template>
        </tr>
        <tr class="actual">
          <td class="title">
            <div class="circle"></div>
            <span class="sea-route-category-label">実績航路</span>
          </td>
          <template v-for="key in Object.keys(tableHeaderData)">
            <td class="value">
              <div v-if="!tableHeaderData[key].isTimeFormat">
                <span>
                  {{ actualRouteTableData[key] }}
                </span>
                <span class="unit">
                  {{ tableHeaderData[key].unit }}
                </span>
              </div>
              <div v-else>
                <span>
                  {{ actualRouteTableData[key].hour }}
                </span>
                <span class="unit"> h </span>
                <span>
                  {{ actualRouteTableData[key].min }}
                </span>
                <span class="unit"> m </span>
              </div>
            </td>
          </template>
        </tr>
        <tr class="recommend">
          <td class="title">
            <div class="circle circle__recommend"></div>
            <span class="sea-route-category-label">推奨航路</span>
          </td>
          <template v-for="key in Object.keys(tableHeaderData)">
            <td class="value">
              <div v-if="!tableHeaderData[key].isTimeFormat">
                <span>
                  {{ recomendedRouteTableData[key] }}
                </span>
                <span class="unit">
                  {{ tableHeaderData[key].unit }}
                </span>
              </div>
              <div v-else>
                <span>
                  {{ recomendedRouteTableData[key].hour }}
                </span>
                <span class="unit"> h </span>
                <span>
                  {{ recomendedRouteTableData[key].min }}
                </span>
                <span class="unit"> m </span>
              </div>
            </td>
          </template>
        </tr>
        <tr class="usual">
          <td class="title">
            <div class="circle circle__usual"></div>
            <span class="sea-route-category-label">計画航路</span>
          </td>
          <template v-for="key in Object.keys(tableHeaderData)">
            <td class="value">
              <div v-if="!tableHeaderData[key].isTimeFormat">
                <span>
                  {{ usualRouteTableData[key] }}
                </span>
                <span class="unit">
                  {{ tableHeaderData[key].unit }}
                </span>
              </div>
              <div v-else>
                <span>
                  {{ usualRouteTableData[key].hour }}
                </span>
                <span class="unit"> h </span>
                <span>
                  {{ usualRouteTableData[key].min }}
                </span>
                <span class="unit"> m </span>
              </div>
            </td>
          </template>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("fuelConsumption");

import { VOYAGE_TABLE_HEADERS } from "../../../Constants.js";

export default {
  data() {
    return {
      actualRouteItems: {},
    };
  },
  computed: {
    ...mapGetters([
      "getRouteAgreementRate",
      "getUsualRouteTableData",
      "getRecomendedRouteTableData",
      "getActualRouteTableData",
      "getExistsRecommendedAggregatedData",
    ]),

    tableHeaderData() {
      return VOYAGE_TABLE_HEADERS;
    },
    routeAgreementRate() {
      if (isNaN(this.getRouteAgreementRate)) return "-";
      return Math.round(this.getRouteAgreementRate * 100);
    },
    usualRouteTableData() {
      if (!this.getUsualRouteTableData) return {};
      return this.getUsualRouteTableData;
    },
    recomendedRouteTableData() {
      if (!this.getRecomendedRouteTableData) return {};
      return this.getRecomendedRouteTableData;
    },
    actualRouteTableData() {
      if (!this.getExistsRecommendedAggregatedData) return {};
      return this.getExistsRecommendedAggregatedData;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/aisea/variables";
@import "src/assets/scss/aisea/typography";
@import "src/assets/scss/aisea/fuel-consumption";

.map-info-table {
  @extend .panel-card-outline;
  border-radius: 4px;
  margin-top: 8px;

  .recommended-route-reference-rate {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;

    .reference-rate-value {
      font-size: 32px;
      font-weight: 600;
      color: $aisea-blue;
      margin-left: 12px;
    }

    .reference-rate-unit {
      font-size: 14px;
      font-weight: 600;
      color: $aisea-blue;
      margin-left: 4px;
    }
  }

  .panel-card-view {
    border: none;
    padding: 0;
  }

  .vertical-divider {
    width: 1px;
    height: 120px;
    background-color: $panel-card-border-color;
  }

  .category-label {
    font-size: 12px;
  }

  .table-right {
    overflow-x: scroll;

    .route-data-table {
      padding: 0 16px;
      width: auto;
      white-space: nowrap;

      .item-category-label {
        padding: 6px 0px 6px 20px;
        font-size: 12px;
        font-weight: 400;
        color: $aisea-dark-gray;
      }

      td {
        text-align: right;
      }

      td.title {
        display: flex;
        align-items: center;
        text-align: left;
      }

      .value {
        font-size: 13px;
        font-weight: 600;
      }

      .unit {
        font-size: 10px;
      }

      .circle {
        width: 12px;
        height: 12px;
        border-radius: 100%;
        margin: 4px;
        margin-right: 8px;
      }

      .sea-route-category-label {
        font-size: 12px;
        font-weight: 600;
        color: $aisea-dark-gray;
      }

      .actual {
        .value {
          color: $aisea-blue;
        }

        .circle {
          background-color: $map-actual-color;
        }
      }

      .usual {
        .circle {
          background-color: $map-usual-color;
        }
      }

      .recommend {
        .circle {
          background-color: $map-recommended-color;
        }
      }
    }
  }
}
</style>
